<div class="card shadow-sm rounded-3">
  <div class="card-body py-2">
    <div class="pb-2">
      <div class="d-flex justify-content-between align-items-center mb-0">
        <h4 class="fw-bold text-dark m-0">
          <i class="las la-cog"></i>
          {{ 'PROPERTY.CONFIGURATIONS' | translate }}
        </h4>
        <button (click)="onAdd()" class="btn btn-primary btn-sm py-2" *ngCan="'utility-provider-configurations.store'">
          <i class="las la-plus"></i>
          {{ 'PROPERTY.NEW_CONFIGURATION' | translate }}
        </button>
      </div>
      <p class="text-muted mb-0">{{ "PROPERTY.CONFIG_DESCRIPTION" | translate }}</p>
    </div>
    <app-property-providers #propertyProviders [id]="property.id"></app-property-providers>
  </div>
</div>
